import { Typography } from "@material-ui/core"
import './SubTitleBlock.scss'
import DynamicHtml from "../../molecules/DynamicHtml"

const SubTitleBlock = ({ title }: any) => {
    return <div className="subtitleBlock">
        <Typography variant='subtitle2' color='textPrimary' className="subtitle color-grey" noWrap={false} align='center'>
            <DynamicHtml content={title} />
        </Typography>
    </div>
}

export default SubTitleBlock